module.exports = __webpack_public_path__ + "img/IT0003131116436.99f1650a.png";